// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vx_a bhh_b"};